import React from "react";
import { Link } from "react-router-dom";
import { Rocket, ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/retention";
import ComplianceDisclaimer from "@/components/public/ComplianceDisclaimer";

/**
 * Phase 11.5 — Affiliate Program introduction.
 * INTENTIONALLY LIGHT. Explains the *role* of affiliates in ~3 bullets,
 * routes to /affiliate-zone for full program details and /ecosystem for
 * the broader picture. Required: <ComplianceDisclaimer> inline.
 */
const BULLETS = [
  "Affiliates help spread awareness.",
  "Affiliates help introduce customers.",
  "Affiliates may help introduce drivers, stores, or future franchisees.",
];

export default function AffiliateIntroSection({ id = "home-affiliate" }) {
  return (
    <section
      id={id}
      data-testid={id}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="eyebrow flex items-center gap-2"><Rocket className="h-3 w-3" /> Affiliate Program</div>
          <h2 className="font-anton text-3xl sm:text-4xl uppercase mt-3 leading-[0.95]">
            Earn with the brand.<br /><span className="text-lifted-green">Help us grow.</span>
          </h2>
          <ul className="mt-5 space-y-2 max-w-xl">
            {BULLETS.map((b) => (
              <li key={b} className="text-lifted-text text-sm flex gap-2">
                <span className="text-lifted-green">›</span><span>{b}</span>
              </li>
            ))}
          </ul>
          <p className="text-[0.7rem] text-lifted-mute mt-3">
            All driver, store, and franchise applicants remain subject to Lifted approval requirements.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link
              to="/affiliate-zone"
              data-testid="affiliate-intro-cta-learn"
              className="btn-lifted"
              onClick={() => trackEvent("affiliate_cta_click", { surface: "affiliate_intro", cta: "learn_more" })}
            >
              Learn more <ArrowRight className="h-3 w-3" />
            </Link>
            <Link
              to="/ecosystem"
              data-testid="affiliate-intro-cta-ecosystem"
              className="btn-ghost"
              onClick={() => trackEvent("ecosystem_preview_click", { surface: "affiliate_intro" })}
            >
              How it fits in the ecosystem
            </Link>
          </div>
          <ComplianceDisclaimer variant="inline" testIdSuffix="home" />
        </div>
        <div className="lg:col-span-5 flex justify-center" />
      </div>
    </section>
  );
}
